// For naming conventions that we may want to share between components...
// If a given component wants to use some, but not all, of the options in a given enum,
// Prefer to `Omit<>` or `extend` the type.

import { Placement as BootstrapPlacement } from 'react-bootstrap/esm/types';

export const Appearance = {
  FILLED: 'filled',
  OUTLINED: 'outlined',
  EMPTY: 'empty'
} as const;
export type AppearanceType = (typeof Appearance)[keyof typeof Appearance];

export const Size = {
  SM: 'small',
  MD: 'medium',
  LG: 'large'
} as const;
export type SizeType = (typeof Size)[keyof typeof Size];
export type LimitedSizeType = Exclude<SizeType, typeof Size.MD>;

export const Design = {
  BRAND: 'brand',
  NEUTRAL: 'neutral'
} as const;
export type DesignType = (typeof Design)[keyof typeof Design];

export const Intent = {
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
  SUCCESS: 'success'
} as const;
export type IntentType = (typeof Intent)[keyof typeof Intent];
export const INTENT_OPTIONS: IntentType[] = [
  Intent.INFO,
  Intent.WARNING,
  Intent.ERROR,
  Intent.SUCCESS
];

export const Background = {
  LIGHT: 'light',
  DARK: 'dark'
} as const;
export type BackgroundType = (typeof Background)[keyof typeof Background];

export const CheckState = {
  UNCHECKED: 'unchecked',
  CHECKED: 'checked',
  INDETERMINATE: 'indeterminate'
} as const;
export type CheckStateType = (typeof CheckState)[keyof typeof CheckState];

export const StretchMode = {
  FILL: 'fill',
  FIT: 'fit'
} as const;
export type StretchModeType = (typeof StretchMode)[keyof typeof StretchMode];

// Options for placement prop on Bootstrap's Overlays, Modals, Popovers, Tooltips, etc.
export const Placement = {
  AUTO: 'auto',
  AUTO_START: 'auto-start',
  AUTO_END: 'auto-end',
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left',
  TOP_START: 'top-start',
  TOP_END: 'top-end',
  RIGHT_START: 'right-start',
  RIGHT_END: 'right-end',
  BOTTOM_START: 'bottom-start',
  BOTTOM_END: 'bottom-end',
  LEFT_START: 'left-start',
  LEFT_END: 'left-end'
} as const satisfies Record<string, BootstrapPlacement>;
export type PlacementType = (typeof Placement)[keyof typeof Placement];
export const PLACEMENT_OPTIONS: PlacementType[] = Object.values(Placement);

export interface Dimensions {
  width: number;
  height: number;
}
